import React from 'react';
import {PropTypes} from 'prop-types';
import {OrderBusinessBox} from 'components/fair/fair-order';
import {connect} from 'react-redux';
import {Fairs} from 'base/api';
import ReactPaginate from 'react-paginate';
import {toastr} from 'react-redux-toastr';
import axios from 'axios';
import cookie from 'react-cookie';
import CONFIG from 'base/constants/config';
import { ShowIf } from 'components/utils';
import {UploadImage} from 'components/UI/Image';

class OrdersOfBusinessList extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      orders: [],
      total: 0,
      offset: 0,
      pageCount: 0,
      searchTerm: '',
      categoryId: [],
      API_URL: '',
      access_token: cookie.load('accessToken') || '',
      typeView: 'LIST',
      item: {},
      orderDetails: [],
      order: {},
      items: {},
      selected: 0
    }

    this.fnCount = `businesses/${this.props.match.params.idBusiness}/orderBusinesses/count`;
    this.findStatus = 1;
  }

  componentDidMount() {

    Fairs.actions.get.request({id: this.props.match.params.id}).then(response => {;
      if (response.data) {
        this.setState({
          API_URL: response.data.fair.apiUrl
        }, () => {
          this.getData();
        })
      }
    });
  }

  getData () {
    axios.get(`${this.state.API_URL}/${this.fnCount}`,{
      params: {
        where: {
          status: this.findStatus
        }
      },
      headers: {
        Authorization: `${this.state.access_token}`
      }
    }).then(response => {
      this.setState({total: response.data.count}, () => {this.loadOrdersFromServer(this.findStatus);})
    }).catch(error => {
      console.log(error)
    })
  }

  loadOrdersFromServer(status) {
    let params = {
      filter: {
        limit: this.props.limit,
        skip: this.state.offset,
        order: 'createdAt DESC',
        include: {
          relation: "order",
          scope: {include: "user"}
        },
        where: {
          status: status
        }
      }
    }
    axios({
      method: 'GET',
      url:`${this.state.API_URL}/businesses/${this.props.match.params.idBusiness}/orderBusinesses`,
      headers: {
        Authorization: `${this.state.access_token}`
      },
      params
    }).then(response => {
      let orders = response.data || [];
      let pageCount = Math.ceil(this.state.total / this.props.limit);
      this.setState({
        pageCount,
        orders
      });
    }).catch(error => {
      console.log(error)
    })
  }

  handlePageClick = (data) => {
    let selected = data.selected;
    let offset = Math.ceil(selected * this.props.limit);

    this.setState({
      offset: offset,
      selected
    }, () => {
      this.loadOrdersFromServer(this.findStatus);
    });
  };

  actionPanel(item) {
    return(
      <div>

      </div>
    )
  }

  render() {
    let User = this.state.order.user || {}
    return (
      <div>
        <table className="table table-striped">
          <thead>
            <tr>
              <th style={{width: 70, minWidth: 70, maxWidth: 70}}>#</th>
              <th style={{minWidth: 270}}>Người đặt hàng</th>
              <th style={{width: 180, minWidth: 180, maxWidth: 180}}>Trạng thái</th>
              <th style={{width: 160, minWidth: 160, maxWidth: 160}}>Ngày đặt</th>
              <th style={{width: 160, minWidth: 160, maxWidth: 160}}>Tổng tiền</th>
            </tr>
          </thead>
          {
            this.state.orders.map((order, i) => {
              return (
                <OrderBusinessBox {...order} className='' index={(i + 1 + ((this.state.selected) * this.props.limit))}
                  actionPanel={this.actionPanel(order)}
                />
              );
            })
          }
          <tfoot>
            <tr>
              <td colSpan='5'>
                <ReactPaginate previousLabel={"previous"}
                  nextLabel={"next"}
                  breakLabel={<a href="">...</a>}
                  breakClassName={"break-me"}
                  pageCount={this.state.pageCount}
                  marginPagesDisplayed={2}
                  pageRangeDisplayed={5}
                  onPageChange={this.handlePageClick}
                  containerClassName={"pagination"}
                  subContainerClassName={"pages pagination"}
                  activeClassName={"active"} />
              </td>
            </tr>
          </tfoot>

        </table>

      </div>
    );
  }
}

const mapStateToProps = function(state) {
  return {
    products: state.fairs.products
  };
}

OrdersOfBusinessList.PropTypes = {
  status: PropTypes.oneOf(['PENDING', 'CLOSED', 'CANCELED']),
  limit: PropTypes.number
}

OrdersOfBusinessList.defaultProps = {
  status: 'PENDING',
  limit: 20
}

export default connect(mapStateToProps)(OrdersOfBusinessList);


// WEBPACK FOOTER //
// ./components/fair/fair-order/OrdersOfBusinessList.jsx